import { Dispatch } from "redux";
import {
  SET_LOGIN,
  SET_LOGOUT,
  SetLoginAction,
  SetLogoutAction,
} from "../../actions-Types/actionTypes";
import { loginResponseData } from "../../../types/login";

export const loginDetails =
  (data: loginResponseData) => async (dispatch: Dispatch<SetLoginAction>) => {
    try {
      dispatch({
        type: SET_LOGIN,
        payload: data,
      });
    } catch (err) {
      console.error("Failed to dispatch login action", err);
    }
  };
  
export const setUserLogoutData =
  () => async (dispatch: Dispatch<SetLogoutAction>) => {
    try {
      dispatch({
        type: SET_LOGOUT,
        payload: undefined,
      });
    } catch (err) {
      console.error("Failed to dispatch Logout action", err);
    }
  };
